import { cn } from "@/lib/utils";
import { Link, useLocation } from "@tanstack/react-router";

export function Footer() {
  const location = useLocation();
  return (
    <footer
      className={cn(
        location.pathname === "/"
          ? "fixed right-0 bottom-0 left-0 z-50 border-border border-t bg-background"
          : "mt-6 border-border border-t backdrop-blur-sm",
      )}
    >
      <div className="container mx-auto max-w-4xl px-4 py-3">
        <div className="flex flex-row items-center justify-between gap-3 sm:flex-row">
          {/* Sol taraf - Logo ve Copyright */}
          <div className="flex items-center gap-4">
            <Link to="/" className="flex items-center space-x-2">
              <div className="font-bold text-sm">
                <span className="text-primary">Atalay</span>
                <span className="text-foreground">TheCoach</span>
              </div>
            </Link>
            <div className="text-muted-foreground text-xs">
              © {new Date().getFullYear()}
            </div>
          </div>

          {/* Orta - Hızlı Linkler */}
          <div className="hidden md:block">
            <div className="flex items-center gap-4 text-xs ">
              <Link
                to="/essay"
                className="text-muted-foreground transition-colors hover:text-primary"
              >
                İçerikler ve Hesaplayıcılar
              </Link>
              <Link
                to="/forum"
                className="text-muted-foreground transition-colors hover:text-primary"
              >
                Forum
              </Link>
            </div>
          </div>

          <div className="flex items-center space-x-2">
            <a
              href="https://instagram.com/atalaythecoach"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground transition-colors hover:text-primary"
            >
              <span className="sr-only">Instagram</span>
              <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 24 24">
                <path d="M7.75 2A5.75 5.75 0 0 0 2 7.75v8.5A5.75 5.75 0 0 0 7.75 22h8.5A5.75 5.75 0 0 0 22 16.25v-8.5A5.75 5.75 0 0 0 16.25 2h-8.5zm0 1.5h8.5A4.25 4.25 0 0 1 20.5 7.75v8.5A4.25 4.25 0 0 1 16.25 20.5h-8.5A4.25 4.25 0 0 1 3.5 16.25v-8.5A4.25 4.25 0 0 1 7.75 3.5zm4.25 2.75a5 5 0 1 0 0 10 5 5 0 0 0 0-10zm0 1.5a3.5 3.5 0 1 1 0 7 3.5 3.5 0 0 1 0-7zm5.25.75a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" />
              </svg>
            </a>
            <a
              href="https://youtube.com/@atalaythecoach"
              target="_blank"
              rel="noopener noreferrer"
              className="text-muted-foreground transition-colors hover:text-primary"
            >
              <span className="sr-only">YouTube</span>
              <svg className="h-3 w-3" fill="currentColor" viewBox="0 0 24 24">
                <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
              </svg>
            </a>
            <a
              href="mailto:info@atalaythecoach.com"
              className="text-muted-foreground transition-colors hover:text-primary"
            >
              <span className="sr-only">Email</span>
              <svg
                className="h-3 w-3"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M3 8l7.89 4.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"
                />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
